
<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import store from './store/index'

export default {
  name: 'App',
  data(){
	return {
		products: null
	}
  },
  components: {},
  mounted(){
    console.log(process.env.VUE_APP_REST_URL)
  },
  async created(){
    await store.dispatch('fetchProducts')
  },
  metaInfo:{
      title:'SMC - Syndicat des Maisons de Cognac',
      meta: [
          {
              name:"description",
              content: "      description: \"L'organisation professionnelle représentative des Maisons de Cognac a pour mission de représenter et défendre les intérêts de ses membres\",\n"
          },
          {
              property:"og:locale",
              content:"fr_FR"
          },
          {
              property: "og:type",
              content: "PANORAMA - Syndicat des Maisons de Cognac"
          },
          {
              property: "og:description",
              content: "L'&#039;'organisation professionnelle représentative des Maisons de Cognac a pour mission de représenter et défendre les intérêts de ses membres"
          },
          {
              property: "og:url",
              content: "https://www.maisons-cognac.fr/"
          },
          {
              property: "og:site_nam",
              content: "SMC Cognac"
          },
          {
              property: "article:modified_time",
              content: "2023-04-27T09:25:23+00:00"
          },
          {
              property: "og:image",
              content: "https://www.maisons-cognac.fr/wp-content/uploads/2023/03/PANORAMA_MENU_im4.jpg"
          },
          {
              property: "og:image:width",
              content: "739"
          },
          {
              property: "og:image:height",
              content: "620"
          },
          {
              property: "twitter:card",
              content: "summary_large_image"
          },
          {
              property: "twitter:title",
              content: "SMC - Syndicat des Maisons de Cognac"
          },
          {
              property: "twitter:description",
              content: "L'organisation professionnelle représentative des Maisons de Cognac a pour mission de représenter et défendre les intérêts de ses membres"
          },
          {
              property: "twitter:image",
              content: "https://www.maisons-cognac.fr/wp-content/uploads/2023/03/PANORAMA_MENU_im4.jpg"
          },
          {
              name: "twitter:label1",
              content: "Durée de lecture estimée"
          },
          {
              name: "twitter:data1",
              content: "1 minute"
          }
      ]
  }
}
</script>
<style scoped>
  @media(min-width:1500px){
    
  }
</style>
